import { FC, useCallback } from 'react';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { useNotification } from 'components/Notifications';

type Props = TextFieldProps;

const CopyableTextField: FC<Props> = ({ value, ...props }) => {
  const { pop } = useNotification();

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(value as string);
    pop('Nukopijuota');
  }, [pop, value]);

  return (
    <TextField
      variant="standard"
      value={value}
      {...props}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleCopy} size="small">
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default CopyableTextField;
